import axios from 'axios';

const api = axios.create({
  baseURL: 'https://localhost:4000', // Example API
});

export const getUsers = () => api.get('/users');
export const getUser = (id) => api.get(`/users/${id}`);
export const createUser = (user) => api.post('/users', user);
export const updateUser = (id, user) => api.put(`/users/${id}`, user);
export const deleteUser = (id) => api.delete(`/users/${id}`);

export const fetchFiles = async (clientId, folder) => {
  const response = await axios.get(`/files/${clientId}/${folder}`);
  return response.data;
};

export const uploadFile = async ({ clientId, folder, file }) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`/upload/${clientId}/${folder}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// export const downloadFile = (clientId, folder, fileName) => {
//   window.open(`/download/${clientId}/${folder}/${fileName}`, '_blank');
// };


const API_URL = 'https://api-4h4srbodqa-uc.a.run.app';

export const fetchTasks = async () => {
  const response = await axios.get(`${API_URL}/tasks`);
  return response.data;
};

export const updateTask = async ({ taskId, ...updatedTask }) => {
  const response = await axios.put(`${API_URL}/tasks/${taskId}`, updatedTask);
  return response.data;
};

export const completeTask = async (taskId) => {
  const response = await axios.patch(`${API_URL}/tasks/${taskId}/complete`);
  return response.data;
};

export const addTask = async (taskData) => {
  const response = await axios.post(`${API_URL}/tasks`, taskData);
  return response.data;
};


export const downloadFile = async (clientId, folder, fileName) => {
  try {
    const response = await fetch(`${API_URL}/download/${clientId}/${folder}/${encodeURIComponent(fileName)}`);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Download failed');
    }

    const data = await response.json();
    
    // Create a hidden anchor element to trigger download
    const link = document.createElement('a');
    link.href = data.downloadUrl;
    link.setAttribute('download', data.fileName);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
};